"use strict";

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _get = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var RDFDM = require("@rdfjs/data-model");

var Expressions_1 = require("./Expressions");

var C = require("../util/Consts");

var Err = require("../util/Errors");

var Term =
/*#__PURE__*/
function () {
  function Term() {
    _classCallCheck(this, Term);

    this.expressionType = Expressions_1.ExpressionType.Term;
  }

  _createClass(Term, [{
    key: "str",
    value: function str() {
      throw new Err.InvalidArgumentTypes([this], C.RegularOperator.STR);
    }
  }, {
    key: "coerceEBV",
    value: function coerceEBV() {
      throw new Err.EBVCoercionError(this);
    }
  }]);

  return Term;
}();

exports.Term = Term; // NamedNodes -----------------------------------------------------------------

var NamedNode =
/*#__PURE__*/
function (_Term) {
  _inherits(NamedNode, _Term);

  function NamedNode(value) {
    var _this;

    _classCallCheck(this, NamedNode);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NamedNode).call(this));
    _this.value = value;
    _this.termType = 'namedNode';
    return _this;
  }

  _createClass(NamedNode, [{
    key: "toRDF",
    value: function toRDF() {
      return RDFDM.namedNode(this.value);
    }
  }, {
    key: "str",
    value: function str() {
      return this.value;
    }
  }]);

  return NamedNode;
}(Term);

exports.NamedNode = NamedNode; // BlankNodes -----------------------------------------------------------------

var BlankNode =
/*#__PURE__*/
function (_Term2) {
  _inherits(BlankNode, _Term2);

  function BlankNode(value) {
    var _this2;

    _classCallCheck(this, BlankNode);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(BlankNode).call(this));
    _this2.value = value;
    _this2.termType = 'blankNode';
    _this2.value = value;
    return _this2;
  }

  _createClass(BlankNode, [{
    key: "toRDF",
    value: function toRDF() {
      return RDFDM.blankNode(this.value);
    }
  }], [{
    key: "nextID",
    value: function nextID() {
      BlankNode._nextID += 1;
      return BlankNode.nextID.toString();
    }
  }]);

  return BlankNode;
}(Term);

BlankNode._nextID = 0;
exports.BlankNode = BlankNode; // Literals-- -----------------------------------------------------------------

var Literal =
/*#__PURE__*/
function (_Term3) {
  _inherits(Literal, _Term3);

  function Literal(typedValue, typeURL, strValue, language) {
    var _this3;

    _classCallCheck(this, Literal);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Literal).call(this));
    _this3.typedValue = typedValue;
    _this3.typeURL = typeURL;
    _this3.strValue = strValue;
    _this3.language = language;
    _this3.termType = 'literal';
    _this3.type = C.type(typeURL.value);
    return _this3;
  }

  _createClass(Literal, [{
    key: "toRDF",
    value: function toRDF() {
      return RDFDM.literal(this.strValue || this.str(), this.language || this.typeURL);
    }
  }, {
    key: "str",
    value: function str() {
      return this.strValue || this.typedValue.toString();
    }
  }]);

  return Literal;
}(Term);

exports.Literal = Literal;

var NumericLiteral =
/*#__PURE__*/
function (_Literal) {
  _inherits(NumericLiteral, _Literal);

  function NumericLiteral() {
    _classCallCheck(this, NumericLiteral);

    return _possibleConstructorReturn(this, _getPrototypeOf(NumericLiteral).apply(this, arguments));
  }

  _createClass(NumericLiteral, [{
    key: "coerceEBV",
    value: function coerceEBV() {
      return !!this.typedValue;
    }
  }, {
    key: "toRDF",
    value: function toRDF() {
      var term = _get(_getPrototypeOf(NumericLiteral.prototype), "toRDF", this).call(this);

      if (!isFinite(this.typedValue)) {
        term.value = term.value.replace('Infinity', 'INF');
      }

      return term;
    }
  }, {
    key: "str",
    value: function str() {
      return this.strValue || NumericLiteral.specificFormatters[this.type](this.typedValue);
    }
  }]);

  return NumericLiteral;
}(Literal);

NumericLiteral.specificFormatters = {
  integer: function integer(value) {
    return value.toFixed();
  },
  float: function float(value) {
    return value.toString();
  },
  decimal: function decimal(value) {
    return value.toString();
  },
  // // Be consistent with float
  // decimal: (value) => {
  //   const jsDecimal = value.toString();
  //   return jsDecimal.match(/\./)
  //     ? jsDecimal
  //     : jsDecimal + '.0';
  // },
  // https://www.w3.org/TR/xmlschema-2/#double
  double: function double(value) {
    var jsExponential = value.toExponential();

    var _jsExponential$split = jsExponential.split('e'),
        _jsExponential$split2 = _slicedToArray(_jsExponential$split, 2),
        jsMantisse = _jsExponential$split2[0],
        jsExponent = _jsExponential$split2[1]; // leading + must be removed for integer
    // https://www.w3.org/TR/xmlschema-2/#integer


    var exponent = jsExponent.replace(/\+/, ''); // SPARQL test suite prefers trailing zero's

    var mantisse = jsMantisse.match(/\./) ? jsMantisse : jsMantisse + '.0';
    return "".concat(mantisse, "E").concat(exponent);
  }
};
exports.NumericLiteral = NumericLiteral;

var BooleanLiteral =
/*#__PURE__*/
function (_Literal2) {
  _inherits(BooleanLiteral, _Literal2);

  function BooleanLiteral(typedValue, strValue) {
    var _this4;

    _classCallCheck(this, BooleanLiteral);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(BooleanLiteral).call(this, typedValue, C.make(C.TypeURL.XSD_BOOLEAN), strValue));
    _this4.typedValue = typedValue;
    _this4.strValue = strValue;
    return _this4;
  }

  _createClass(BooleanLiteral, [{
    key: "coerceEBV",
    value: function coerceEBV() {
      return !!this.typedValue;
    }
  }]);

  return BooleanLiteral;
}(Literal);

exports.BooleanLiteral = BooleanLiteral;

var DateTimeLiteral =
/*#__PURE__*/
function (_Literal3) {
  _inherits(DateTimeLiteral, _Literal3);

  // strValue is mandatory here because toISOString will always add
  // milliseconds, even if they were not present.
  function DateTimeLiteral(typedValue, strValue) {
    var _this5;

    _classCallCheck(this, DateTimeLiteral);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(DateTimeLiteral).call(this, typedValue, C.make(C.TypeURL.XSD_DATE_TIME), strValue));
    _this5.typedValue = typedValue;
    _this5.strValue = strValue;
    return _this5;
  }

  return DateTimeLiteral;
}(Literal);

exports.DateTimeLiteral = DateTimeLiteral;

var LangStringLiteral =
/*#__PURE__*/
function (_Literal4) {
  _inherits(LangStringLiteral, _Literal4);

  function LangStringLiteral(typedValue, language) {
    var _this6;

    _classCallCheck(this, LangStringLiteral);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(LangStringLiteral).call(this, typedValue, C.make(C.TypeURL.RDF_LANG_STRING), typedValue, language));
    _this6.typedValue = typedValue;
    _this6.language = language;
    return _this6;
  }

  _createClass(LangStringLiteral, [{
    key: "coerceEBV",
    value: function coerceEBV() {
      return this.strValue.length !== 0;
    }
  }]);

  return LangStringLiteral;
}(Literal);

exports.LangStringLiteral = LangStringLiteral; // https://www.w3.org/TR/2004/REC-rdf-concepts-20040210/#dfn-plain-literal
// https://www.w3.org/TR/sparql11-query/#defn_SimpleLiteral
// https://www.w3.org/TR/sparql11-query/#func-strings
// This does not include language tagged literals

var StringLiteral =
/*#__PURE__*/
function (_Literal5) {
  _inherits(StringLiteral, _Literal5);

  function StringLiteral(typedValue) {
    var _this7;

    _classCallCheck(this, StringLiteral);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(StringLiteral).call(this, typedValue, C.make(C.TypeURL.XSD_STRING), typedValue));
    _this7.typedValue = typedValue;
    return _this7;
  }

  _createClass(StringLiteral, [{
    key: "coerceEBV",
    value: function coerceEBV() {
      return this.strValue.length !== 0;
    }
  }]);

  return StringLiteral;
}(Literal);

exports.StringLiteral = StringLiteral;
/*
 * This class is used when a literal is parsed, and it's value is
 * an invalid lexical form for it's datatype. The spec defines value with
 * invalid lexical form are still valid terms, and as such we can not error
 * immediately. This class makes sure that the typedValue will remain undefined,
 * and the category 'nonlexical'. This way, only when operators apply to the
 * 'nonlexical' category, they will keep working, otherwise they will throw a
 * type error.
 * This seems to match the spec, except maybe for functions that accept
 * non-lexical values for their datatype.
 *
 * See:
 *  - https://www.w3.org/TR/xquery/#dt-type-error
 *  - https://www.w3.org/TR/rdf-concepts/#section-Literal-Value
 *  - https://www.w3.org/TR/xquery/#dt-ebv
 *  - ... some other more precise thing i can't find...
 */

var NonLexicalLiteral =
/*#__PURE__*/
function (_Literal6) {
  _inherits(NonLexicalLiteral, _Literal6);

  function NonLexicalLiteral(typedValue, typeURL, strValue, language) {
    var _this8;

    _classCallCheck(this, NonLexicalLiteral);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(NonLexicalLiteral).call(this, typedValue, typeURL, strValue, language));
    _this8.typedValue = undefined;
    _this8.type = 'nonlexical';
    _this8.shouldBeCategory = C.type(typeURL.value);
    return _this8;
  }

  _createClass(NonLexicalLiteral, [{
    key: "coerceEBV",
    value: function coerceEBV() {
      var isNumericOrBool = C.PrimitiveNumericTypes.contains(this.shouldBeCategory) || this.shouldBeCategory === 'boolean';

      if (isNumericOrBool) {
        return false;
      }

      throw new Err.EBVCoercionError(this);
    }
  }]);

  return NonLexicalLiteral;
}(Literal);

exports.NonLexicalLiteral = NonLexicalLiteral;